{
  "name": "bisual-workers",
  "packageManager": "pnpm@9.15.9",
  "version": "0.56.6",
  "description": "Aplicación Bisual Intranet",
  "author": "Bisual",
  "main": "electron/main.js",
  "scripts": {
    "ng": "ng",
    "start": "ng build",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "format": "prettier --no-editorconfig --write \"src/**/*.{ts,html,css,scss,json,yml}\"",
    "format:check": "prettier --no-editorconfig --check \"src/**/*.{ts,html,css,scss,json,yml}\"",
    "check:patches": "node scripts/check-patches.mjs",
    "dist": "electron-builder",
    "electron:dev": "pnpm run check:patches && node electron/ensure-electron-location-plist.js && concurrently -k \"ng build --watch\" \"wait-on dist/bisual-workers/browser/index.html && electron .\"",
    "electron:reset-location": "node electron/ensure-electron-location-plist.js --reset-location",
    "electron:rebuild-native": "electron-builder install-app-deps",
    "electron:build": "pnpm run check:patches && electron-builder --mac --publish never"
  },
  "build": {
    "appId": "com.bisual.intranet",
    "productName": "Bisual Intranet",
    "directories": {
      "output": "dist_electron"
    },
    "files": [
      "dist/",
      "electron/**/*"
    ],
    "protocols": [
      {
        "name": "Bisual Intranet",
        "schemes": [
          "bisualintranet"
        ]
      }
    ],
    "asarUnpack": [
      "node_modules/node-mac-permissions/**/*"
    ],
    "publish": [
      {
        "provider": "generic",
        "url": "https://api.bisual.net/storage/intranet/dist_electron/"
      }
    ],
    "mac": {
      "target": [
        "zip",
        "dmg"
      ],
      "icon": "assets/icons/mac/icon.icns",
      "artifactName": "BisualIntranetApp-v${version}-${os}.${ext}",
      "hardenedRuntime": true,
      "entitlements": "build/entitlements.mac.plist",
      "entitlementsInherit": "build/entitlements.mac.plist",
      "gatekeeperAssess": false,
      "identity": "CONSULTORIA BISUAL SOCIEDAD LIMITADA",
      "extendInfo": {
        "NSAudioCaptureUsageDescription": "Bisual Intranet necesita capturar el audio del sistema para grabar reuniones con pantalla compartida.",
        "NSScreenCaptureDescription": "Bisual Intranet necesita capturar la pantalla para grabar reuniones.",
        "NSMicrophoneUsageDescription": "Bisual Intranet necesita acceso al micrófono para grabar audio en reuniones.",
        "NSLocationUsageDescription": "Bisual Intranet necesita tu ubicación para registrar en qué oficina estás trabajando.",
        "NSLocationWhenInUseUsageDescription": "Bisual Intranet necesita tu ubicación para registrar en qué oficina estás trabajando.",
        "NSLocationAlwaysUsageDescription": "Bisual Intranet necesita tu ubicación para registrar en qué oficina estás trabajando.",
        "NSLocationAlwaysAndWhenInUseUsageDescription": "Bisual Intranet necesita tu ubicación para registrar en qué oficina estás trabajando."
      }
    },
    "win": {
      "target": "nsis",
      "icon": "assets/icons/win/icon.ico"
    },
    "linux": {
      "target": "AppImage",
      "icon": "assets/icons/png/1024x1024.png"
    },
    "afterSign": "build/notarize.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.6",
    "@angular/cdk": "^22.1.6",
    "@angular/common": "^22.1.6",
    "@angular/compiler": "^22.1.6",
    "@angular/core": "^22.1.6",
    "@angular/forms": "^22.1.6",
    "@angular/material": "^22.1.6",
    "@angular/platform-browser": "^22.1.6",
    "@angular/platform-browser-dynamic": "^22.1.6",
    "@angular/router": "^22.1.6",
    "@bisual/ngx-index-template": "^3.0.1",
    "@electron/notarize": "^2.5.0",
    "@mattlewis92/dom-autoscroller": "^2.4.2",
    "@ng-bootstrap/ng-bootstrap": "^21.0.0",
    "@popperjs/core": "^2.11.5",
    "@tailwindcss/postcss": "^4.3.3",
    "@tinymce/tinymce-angular": "^8.0.0",
    "angular-calendar": "0.32.2",
    "angular-draggable-droppable": "^9",
    "angular-resizable-element": "^8",
    "angularx-flatpickr": "^6.6.0",
    "apexcharts": "^6.10.0",
    "bootstrap": "^5.2.3",
    "calendar-utils": "^0.12.5",
    "date-fns": "^4.4.0",
    "dayjs": "^1.11.18",
    "electron-log": "^5.2.0",
    "electron-updater": "^6.6.2",
    "file-saver": "^2.0.5",
    "flatpickr": "^4.6.13",
    "fs-extra": "^11.2.0",
    "highlight.js": "^11.8.0",
    "ical.js": "^2.1.0",
    "ng-apexcharts": "^3.1.0",
    "ngx-clipboard": "^15.1.0",
    "ngx-dropzone": "^3.1.0",
    "node-mac-permissions": "^2.5.0",
    "positioning": "^3.0.1",
    "postcss": "^8.5.6",
    "pusher-js": "^8.4.0-rc2",
    "ringover-sdk": "^1.1.3",
    "rxjs": "^7.8.0",
    "tailwindcss": "^4.3.3",
    "tinymce": "^7.9.1",
    "tslib": "^2.4.0",
    "turndown": "^7.2.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.5.0",
    "@angular/build": "^22.1.8",
    "@angular/cli": "^22.1.8",
    "@angular/compiler-cli": "^22.1.6",
    "@angular/localize": "^22.1.6",
    "@eslint/js": "^9.0.0",
    "@types/file-saver": "^2.0.5",
    "@types/jasmine": "~3.6.0",
    "@types/node": "^22.0.0",
    "@types/turndown": "^5.0.5",
    "angular-eslint": "22.5.0",
    "concurrently": "^9.0.1",
    "electron": "^33.0.2",
    "electron-builder": "^25.1.8",
    "electron-reload": "^2.0.0-alpha.1",
    "eslint": "^9.39.2",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.5",
    "globals": "^17.3.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~4.3.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "^6.4.0",
    "karma-chrome-launcher": "^3.1.1",
    "karma-coverage": "~2.0.3",
    "karma-jasmine": "^4.0.2",
    "karma-jasmine-html-reporter": "^1.5.0",
    "prettier": "^3.6.2",
    "ts-node": "~8.3.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "8.70.0",
    "wait-on": "^8.0.1"
  },
  "pnpm": {
    "overrides": {
      "cacache@20>lru-cache": "^11.1.0"
    },
    "patchedDependencies": {
      "node-mac-permissions@2.5.0": "patches/node-mac-permissions@2.5.0.patch"
    }
  }
}
